// WLM x Globo integration (pre-render filtering)
(function() {
  if (window.__WLM_GLOBO_HOOKED__) return;
  window.__WLM_GLOBO_HOOKED__ = true;

  function getHandleFromProduct(product) {
    if (!product) return null;
    return (
      product.handle ||
      product.product_handle ||
      product.slug ||
      (product.url && (product.url.match(/\/products\/([^\/?#]+)/) || [])[1]) ||
      null
    );
  }

  function checkIsProductHide(handles = []) {
    if (!handles?.length) return { products: [] };
    
    const results = [];
    const pageSize = 20;
  
    for (let i = 0; i < handles.length; i += pageSize) {
      const url = `/search?view=wlm-api&handle=${handles.slice(i, i + pageSize).join(",")}`;
      const xhr = new XMLHttpRequest();
      xhr.open("GET", url, false);
      xhr.send();
  
      if (xhr.status === 200) {
        try {
          const json = JSON.parse(xhr.responseText);
          results.push(...(json.products || []));
        } catch (e) {
          this.log('Parse error:', e);
        }
      }
    }
    
    return { products: results };
  }

  function filterAllowedHandlesSync(handles) {
    try {
      const { products = [] } = checkIsProductHide(handles);
      const allowed = new Set();
      for (let i = 0; i < products.length; i++) {
        const h = getHandleFromProduct(products[i]);
        if (h) allowed.add(h);
      }
      return allowed;
    } catch (e) {
      return new Set(handles);
    }
  }

  try {
    window.addEventListener(
      'globoFilterSearchCompleted',
      function(ev) {
        try {
          const payload = ev && (ev.detail || ev);
          if (!payload || !payload.result || !Array.isArray(payload.result.products)) return;
          const list = payload.result.products;
          const handles = list.map(getHandleFromProduct).filter(Boolean);
          if (!handles.length) return;
          const allowed = filterAllowedHandlesSync(handles);
          payload.result.products = list.filter(p => allowed.has(getHandleFromProduct(p)));
        } catch (err) {}
      },
      { passive: true }
    );
  } catch (e) {}

  function tryPatchTransform() {
    const gf = window.globofilter;
    if (!gf || typeof gf.transformProducts !== 'function') return false;
    if (gf.__wlmTransformPatched) return true;

    const originalTransform = gf.transformProducts.bind(gf);
    gf.transformProducts = function(products) {
      try {
        if (Array.isArray(products) && products.length) {
          const handles = products.map(getHandleFromProduct).filter(Boolean);
          if (handles.length) {
            const allowed = filterAllowedHandlesSync(handles);
            products = products.filter(p => allowed.has(getHandleFromProduct(p)));
          }
        }
      } catch (e) {}
      return originalTransform(products);
    };
    gf.__wlmTransformPatched = true;
    return true;
  }

  if (!tryPatchTransform()) {
    const timer = setInterval(() => {
      if (tryPatchTransform()) clearInterval(timer);
    }, 100);
    setTimeout(() => clearInterval(timer), 10000);
  }
})();